<template>
	<div class="login_wrap" style="min-height: 820px;">
		<!-- 模块化配置logo -->
		<div v-if="loginBackgroundLogo">
			<img :src="loginBackgroundLogo" alt="" class="login-top" />
		</div>
		<div v-else>
			<div v-if="theme !== 'honghui'">
				<img v-if="theme === 'renshe'" src="@/assets/images/rs_logo.png" alt="" class="logo" />
				<img v-else src="@/assets/images/logo@2x.png" alt="" class="login-top" />
			</div>
		</div>
		<div class="login">
			<div class="bg_width"></div>
			<img :src="loginImg" alt="" class="login-left" />
			<div class="login-box">
				<div class="login-international" v-if="isI18nFlag" @mouseenter="setUpLanguageEnter()" @mouseleave="setUpLanguageLeave()">
					<!-- <img class="fl" v-if="internationalKey == 'zh-CN'" src="../../assets/images/china.png" alt="" />
					<img class="fl" v-else-if="internationalKey == 'en-US'" src="../../assets/images/english.png" alt="" /> -->
					<!-- <img class="fl" v-else-if="internationalKey == 'fr-FR'" src="../../assets/images/france.png" alt="" /> -->
					<span class="fl">
						{{ $t(internationalName) }}
					</span>
					<img src="../../assets/images/down.png" alt="" class="international-img" />
					<ul v-show="setUpLanguageShow" @mouseenter="setUpLanguageEnter()" @mouseleave="setUpLanguageLeave()">
						<li v-for="item in international" :key="item.key" @click="selectChange(item.key, item.val)">
							<!-- <img v-if="item.key == 'zh-CN'" src="../../assets/images/china.png" alt="">
							<img v-else-if="item.key == 'en-US' " src="../../assets/images/english.png" alt=""> -->
							<!-- <img v-else-if="item.key == 'fr-FR'" src="../../assets/images/france.png" alt=""> -->
							<span>{{ $t(item.val) }}</span>
						</li>
					</ul>
				</div>
				<ul class="tabs">
					<li
						:key="item.key"
						v-for="(item, index) in tabsList"
						@click="setActiveName(item.key)"
						:style="index === 0 ? 'margin-right:40px' : ''"
						:class="{ highlight: activeName === item.key }"
					>
						{{ $t(item.val) }}
					</li>
				</ul>
				<div>
					<el-form ref="form" :rules="rules" :model="formData">
						<el-form-item prop="account" class="mt48">
							<!-- <el-input
								:placeholder="activeName === 'password' ? '请输入手机号码/邮箱/账号' : '请输入手机号码/邮箱'"
								v-model="formData.account"
								@keyup.enter.native="onSubmit"
								clearable
							>
							</el-input> -->
							<el-input
								class="phoneInput"
								:placeholder="
									activeName === 'password'
										? $t('MAIN_WEB_ENTER_YOUR_MOBILE_PHONE_NUMBER_AND_EMAIL', {
												text: $t('MAIN_WEB_PLEASE_ENTER_YOUR_MOBILE_PHONE_NUMBER_AND', { text: '请输入手机号码/邮箱' }),
										  })
										: $t('MAIN_WEB_ENTER_YOUR_MOBILE_PHONE_NUMBER_AND_EMAIL', {
												text: $t('MAIN_WEB_PLEASE_ENTER_YOUR_MOBILE_PHONE_NUMBER_AND', { text: '请输入手机号码/邮箱' }),
										  })
								"
								v-model="formData.account"
								@keyup.enter.native="onSubmit"
								clearable
							>
								<el-select v-if="isI18nFlag" v-model="code" @change="handleSelectChange" slot="prepend" style="width: 130px" class="phonePrepend" placeholder="请选择">
									<el-option
										:label="internationalKey === 'zh-CN'? item.cn + ' +' + item.mobile_prefix : item.en + ' +' + item.mobile_prefix"
										:value="item.code"
										v-for="item in contryList"
										:key="item.code"
									></el-option>
								</el-select>
							</el-input>
						</el-form-item>
						<el-form-item prop="password" v-if="activeName === 'password'" ref="password" class="mt32">
							<el-input
								:type="passw"
								:placeholder="$t('MAIN_WEB_ENTER_A_PASSWORD', { text: '请输入密码' })"
								v-model="formData.password"
								@keyup.enter.native="onSubmit"
								key="password"
								clearable
							>
							</el-input>
						</el-form-item>
						<el-form-item v-else prop="authCode" ref="authCode" class="mt32 input_auth_btn">
							<el-input
								:placeholder="$t('MAIN_WEB_PLEASE_ENTER_A_VERIFICATION_CODE', { text: '请输入验证码' })"
								v-model="formData.authCode"
								@keyup.enter.native="onSubmit"
							>
							</el-input>
							<div class="count_down" @click="postAccountGetAuthCode" :class="{ active_btn: 0 < Countdown.time }">
								{{ 0 >= Countdown.time ? $t('MAIN_WEB_OBTAIN_VERIFICATION_CODE', { text: '获取验证码' }) : countTimer }}
							</div>
						</el-form-item>
						<div style="overflow: hidden" v-show="activeName === 'password'" class="forget">
							<router-link class="fr" :to="{ path: `/entrance_new/forget`, query: { account: formData.account,code: this.code } }">{{
								$t('MAIN_WEB_FORGOT_PASSWORD', { text: '忘记密码' })
							}}</router-link>
						</div>
						<el-form-item class="mt76">
							<el-button type="primary" class="login-btn" @click="onSubmit">{{ $t('MAIN_WEB_LOGIN', { text: '登录' }) }}</el-button>
						</el-form-item>
					</el-form>
				</div>
				<!-- <div> -->
				<!-- <span class="res">
                    $t('MAIN_WEB_NO_ACCOUNT_YET',{text:'还没账号？'})
                    <router-link  :to="{ name: 'register' }">$t('MAIN_WEB_REGISTER_NOW',{text:'立即注册'})</router-link>
                </span> -->
				<!-- </div> -->
			</div>
		</div>

		<organ v-if="isShowOrgan" @changeShowOrgan="handleChangeShow"></organ>
		<identity v-if="isShowIdentity" @changeShowIdentity="handleShowIdentity"></identity>
	</div>
</template>

<script>
import MD5 from 'js-md5'
import { mapState } from 'vuex'
import organ from './organ.vue'
import identity from './identity'
import { isPhone, isEmail } from '@/util/validate'
import conf from '../../config/url.js'
import api from '../../api'
import themeStyle from '@wd/lowcode-pc/plugin/theme/index'
import cssVars from 'css-vars-ponyfill'
import contryList from '../../util/country'
export default {
	name: 'login',
	components: {
		organ,
		identity,
	},
	data() {
		return {
			isI18nFlag: false, //判断是否是国际化项目
			internationalName: 'English',
			internationalKey: 'en-US',
			setUpLanguageTimeout: null,
			setUpLanguageShow: false,
			isShowOrgan: false,
			isShowIdentity: false,
			institutionsList: [],
			Countdown: {
				time: 0,
			},
			activeName: 'password',
			passw: 'password',
			tabsList: [
				{ key: 'password', val: 'MAIN_WEB_PASSWORD_LOGON' },
				{ key: 'Verification', val: 'MAIN_WEB_VERIFICATION_CODE_LOGIN' },
			],
			formData: {
				account: '',
				password: '',
				authCode: '',
				type: 1, //1:密码登录，2:验证码登录
			},
			loginImg: '',
			defaultImg: require('../../assets/images/pexels.png'),
			contryList: [],
            mobile_prefix: '86',
            code:'156',
            rules:{
				account: [
                    {
                        validator: this.accountValidator,
						trigger: 'blur',
					},
				],
				password: [
                    {
                        validator: this.passwordValidator,
						trigger: 'blur',
					},
                    // { required: true, message: this.$t('MAIN_WEB_ENTER_A_PASSWORD', { text: '请输入密码' }), trigger: 'blur' }
                ],
				authCode: [
					// { required: true, message: this.$t('MAIN_WEB_PLEASE_ENTER_A_VERIFICATION_CODE', { text: '请输入验证码' }), trigger: 'blur' },
                    // { min: 6, max: 6, message: this.$t('MAIN_WEB_PLEASE_ENTER_A_SIXDIGIT_VERIFICATION_CODE', { text: '请输入六位验证码' }), trigger: 'blur' },
                    {
                        validator: this.authcodeValidator,
						trigger: 'blur',
					},
				],
			},
			loginBackgroundLogo: ''
		}
	},
	computed: {
		...mapState(['theme']),
		countTimer() {
			return this.Countdown.time + 's' + this.$t('MAIN_WEB_THEN_RETRIEVE', { text: '后重新获取' })
		},
		// rules() {
		// 	return {
		// 		account: [
		// 			{
		// 				validator: this.accountValidator,
		// 				trigger: 'blur',
		// 			},
		// 		],
		// 		password: [{ required: true, message: this.$t('MAIN_WEB_ENTER_A_PASSWORD', { text: '请输入密码' }), trigger: 'blur' }],
		// 		authCode: [
		// 			{ required: true, message: this.$t('MAIN_WEB_PLEASE_ENTER_A_VERIFICATION_CODE', { text: '请输入验证码' }), trigger: 'blur' },
		// 			{ min: 6, max: 6, message: this.$t('MAIN_WEB_PLEASE_ENTER_A_SIXDIGIT_VERIFICATION_CODE', { text: '请输入六位验证码' }), trigger: 'blur' },
		// 		],
		// 	}
		// },
		international() {
			return [
				{ key: 'zh-CN', val: '中文' }, //中文
				{ key: 'en-US', val: 'English' }, //英语
				{key:"fr-FR",val: 'Français'}//法语
			]
		},
	},
	created() {
        this.contryList = contryList
        if(this.$route.query.code){
            this.code = this.$route.query.code
            this.handleSelectChange(this.code)
        }
        document.getElementsByTagName('html')[0].setAttribute('lang', this.internationalKey)
		this.formData.account = this.$route.query.account || ''
		this.getConfiguration()
		if (localStorage.getItem('current_language')) {
			let innertational = this.international.filter((item) => item.key == localStorage.getItem('current_language'))
			if (innertational && innertational.length > 0) {
				this.internationalName = innertational[0].val
                this.internationalKey = innertational[0].key
                document.getElementsByTagName('html')[0].setAttribute('lang', this.internationalKey)
			}
		}
	},
	mounted() {
		// localStorage.clear()
		// sessionStorage.clear()
		localStorage.removeItem('token')
		localStorage.removeItem('saasName')
        localStorage.removeItem('saasUcode')
        localStorage.removeItem('identity')
		this.$store.state.nav = []
		var configurationConfig = JSON.parse(localStorage.getItem("configurationConfig"));
		configurationConfig.map((item) => {
			if (item.key === 'login_background_logo') {
				this.loginBackgroundLogo = item.value
			}
		})
	},
	methods: {
        handleSelectChange(val){
            this.mobile_prefix = this.contryList.find(item => item.code === val).mobile_prefix
        },
        accountValidator(rule, value, callback) {
			if (!value) {
				if (this.activeName === 'password') {
					callback(new Error(this.$t('MAIN_WEB_ENTER_YOUR_MOBILE_PHONE_NUMBER_AND_EMAIL', { text: '请输入手机号码/邮箱/账号' })))
				} else {
					callback(new Error(this.$t('MAIN_WEB_PLEASE_ENTER_YOUR_MOBILE_PHONE_NUMBER_AND', { text: '请输入手机号码/邮箱' })))
				}
			} else {
				callback()
			}
        },
        passwordValidator(rule, value, callback){
            if (!value) {
				callback(new Error(this.$t('MAIN_WEB_ENTER_A_PASSWORD', { text: '请输入密码' })))
			} else {
				callback()
			}
        },
        authcodeValidator(rule, value, callback){
            if (!value) {
				callback(new Error(this.$t('MAIN_WEB_PLEASE_ENTER_A_VERIFICATION_CODE', { text: '请输入验证码' })))
			} else if(value.length != 6) {
				callback(new Error(this.$t('MAIN_WEB_PLEASE_ENTER_A_SIXDIGIT_VERIFICATION_CODE', { text: '请输入六位验证码' })))
			} else {
                callback()
            }
        },
        getConfiguration() {
            let mainTheme = sessionStorage.getItem('mainTheme')
            if (mainTheme) {
                this.setTheme(mainTheme)
            }
                    // let frontendConfig = res.data.frontendConfig
                    let  frontendConfig = sessionStorage.getItem('frontendConfig') && JSON.parse(sessionStorage.getItem('frontendConfig'))||[];


                    frontendConfig.map((item) => {
                        if (item.key === 'theme') {
                            if (!mainTheme) {
                                this.setTheme(item.value)
                                sessionStorage.setItem('mainTheme', item.value)
                            }
                        }
                        if (item.key === 'custom_login_background_img' && item.value) {
                            localStorage.setItem('loginBackgroundImg', item.value)
                            // this.$store.commit('setLoginBackgroundImg', item.value)
                        }
                        if (item.key === 'custom_login_img' && item.value) {
                            localStorage.setItem('loginImg', item.value)
                            // this.$store.commit('setLoginImg', item.value)
                        }
                        if (item.key == 'is_i18n') {
                            localStorage.setItem('is_i18n', item.value)
                            // 如果是国际化显示切换语言
                            if (item.value == 'true') {
                                this.isI18nFlag = true
                            } else {
                                this.isI18nFlag = false
                            }
                        }
                    })
                    this.loginImg = localStorage.getItem('loginImg') || this.defaultImg
                    // this.setTheme('init');

                    let websiteLogo = localStorage.getItem('websiteLogo') || sessionStorage.getItem('websiteLogo');
                    if (websiteLogo) {
                        this.$store.commit('setLogo', websiteLogo)
                        localStorage.setItem('websiteLogo', websiteLogo)
                    }
                    /** 培训任务数据统计用到 */

                    
                    localStorage.setItem('theme', theme)
                    let  domain = sessionStorage.getItem('domain') || localStorage.getItem('domain');

                    localStorage.setItem('domain', JSON.stringify(domain) ? JSON.stringify(domain) : '')
                    localStorage.setItem(
                        'configurationConfig',
                        res.data && JSON.stringify(frontendConfig) ? JSON.stringify(frontendConfig) : ''
                    )
                    const a = frontendConfig((item) => item.key === 'is_open_platform_up_commodity')
                    localStorage.setItem('isOpenToPlateform', a.value)
                    /**  * cms 配置网页标题 */

                    let  pageTitle = sessionStorage.getItem('pageTitle') || localStorage.getItem('pageTitle');

                    if (pageTitle) {
                        localStorage.setItem('pageTitle', pageTitle)
                    }
                    document.title =
                        (pageTitle) ||
                        this.$t('MAIN_WEB_SHARING_EDUCATIONAL_RESOURCES_TO_INHERIT_HUMAN_CIVILIZATION', { text: '共享教育资源 传承人类文明' })

        },



        // getConfiguration() {
		// 	let mainTheme = sessionStorage.getItem('mainTheme')
		// 	if (mainTheme) {
		// 		this.setTheme(mainTheme)
		// 	}
		// 	this.$api.configuration
		// 		.getConfiguration(conf.confUrl)
		// 		.then((res) => {
		// 			let frontendConfig = res.data.frontendConfig
		// 			frontendConfig.map((item) => {
		// 				if (item.key === 'theme') {
		// 					if (!mainTheme) {
		// 						this.setTheme(item.value)
		// 						sessionStorage.setItem('mainTheme', item.value)
		// 					}
		// 				}
		// 				if (item.key === 'custom_login_background_img' && item.value) {
		// 					localStorage.setItem('loginBackgroundImg', item.value)
		// 					// this.$store.commit('setLoginBackgroundImg', item.value)
		// 				}
		// 				if (item.key === 'custom_login_img' && item.value) {
		// 					localStorage.setItem('loginImg', item.value)
		// 					// this.$store.commit('setLoginImg', item.value)
		// 				}
		// 				if (item.key == 'is_i18n') {
		// 					localStorage.setItem('is_i18n', item.value)
		// 					// 如果是国际化显示切换语言
		// 					if (item.value == 'true') {
		// 						this.isI18nFlag = true
		// 					} else {
		// 						this.isI18nFlag = false
		// 					}
		// 				}
		// 			})
		// 			this.loginImg = localStorage.getItem('loginImg') || this.defaultImg
		// 			// this.setTheme('init');
		// 			if (res.data && res.data.websiteLogo) {
		// 				this.$store.commit('setLogo', res.data.websiteLogo)
		// 				localStorage.setItem('websiteLogo', res.data.websiteLogo)
		// 			}
		// 			/** 培训任务数据统计用到 */
		// 			this.$store.commit('setTheme', res.data.theme)
		// 			localStorage.setItem('theme', res.data && res.data.theme)
        //
		// 			localStorage.setItem('domain', res.data && JSON.stringify(res.data.domain) ? JSON.stringify(res.data.domain) : '')
		// 			localStorage.setItem(
		// 				'configurationConfig',
		// 				res.data && JSON.stringify(res.data.frontendConfig) ? JSON.stringify(res.data.frontendConfig) : ''
		// 			)
		// 			const a = res.data.frontendConfig.find((item) => item.key === 'is_open_platform_up_commodity')
		// 			localStorage.setItem('isOpenToPlateform', a.value)
		// 			/**  * cms 配置网页标题 */
		// 			if (res.data.pageTitle) {
		// 				localStorage.setItem('pageTitle', res.data.pageTitle)
		// 			}
		// 			document.title =
		// 				(res.data && res.data.pageTitle) ||
		// 				this.$t('MAIN_WEB_SHARING_EDUCATIONAL_RESOURCES_TO_INHERIT_HUMAN_CIVILIZATION', { text: '共享教育资源 传承人类文明' })
		// 		})
		// 		.catch((err) => {
		// 			console.log(err)
		// 			document.title = this.$t('MAIN_WEB_SHARING_EDUCATIONAL_RESOURCES_TO_INHERIT_HUMAN_CIVILIZATION', { text: '共享教育资源 传承人类文明' })
		// 		})
		// },
		async selectChange(key, value) {
            this.$refs.form.clearValidate()
			console.log(key, value, 'key', 'value', this.$t(value))
            localStorage.setItem('current_language', key)
            this.$store.commit('setCurrentLanguage', key)
			this.$i18n.locale = key
			await this.documenetTitle()
			this.internationalKey = key
            this.internationalName = value
            document.getElementsByTagName('html')[0].setAttribute('lang', this.internationalKey)
			this.setUpLanguageTimeout = setTimeout(() => {
				this.setUpLanguageShow = false
			}, 100)
		},
		documenetTitle() {
			document.title =
				localStorage.getItem('pageTitle') ||
				this.$t('MAIN_WEB_SHARING_EDUCATIONAL_RESOURCES_TO_INHERIT_HUMAN_CIVILIZATION', { text: '共享教育资源 传承人类文明' })
		},
		// 切换语言
		setUpLanguageEnter() {
			clearTimeout(this.setUpLanguageTimeout)
			this.setUpLanguageShow = true
		},
		setUpLanguageLeave() {
			this.setUpLanguageTimeout = setTimeout(() => {
				this.setUpLanguageShow = false
			}, 300)
		},
		setTheme(name) {
			const initTheme = (name) => {
				document.documentElement.setAttribute('data-theme', name)
				cssVars({
					silent: true,
					watch: true, // 当添加，删除或修改其<link>或<style>元素的禁用或href属性时，ponyfill将自行调用
					variables: themeStyle[name], // variables 自定义属性名/值对的集合
					onlyLegacy: false, // false  默认将css变量编译为浏览器识别的css样式  true 当浏览器不支持css变量的时候将css变量编译为识别的css
				})
			}
			initTheme(name)
		},
		handleChangeShow(val) {
			this.isShowOrgan = val
			this.isShowIdentity = true
		},
		handleShowIdentity(val) {
			this.isShowIdentity = val
		},
		showPassw() {
			if (this.passw === 'password') {
				this.passw = 'text'
			} else {
				this.passw = 'password'
			}
		},
		async onSubmit() {
			localStorage.removeItem('token')
			localStorage.removeItem('saasName')
            localStorage.removeItem('saasUcode')
            localStorage.removeItem('identity')
			// localStorage.clear()
			// sessionStorage.clear()
			this.isShowOrgan = false
			this.isShowIdentity = false
			this.$refs.form.validate((valid) => {
				if (valid) {
					this.postAccountLogin()
				} else {
					return false
				}
			})
		},
		async postAccountLogin() {
			let data = this.handleParams()
			return this.$api.account_new.postAccountLogin(data).then((res) => {
				if (res.success) {
                    localStorage.setItem('token', res.data)
                    sessionStorage.setItem('token',res.data)
					localStorage.setItem('mobile_prefix', this.mobile_prefix)
					this.isShowOrgan = true
				}
			})
		},
		// 登录参数处理
		handleParams() {
			let hashPassword = ''
			if (this.formData.password) {
				hashPassword = MD5(this.formData.password).toLowerCase()
			}
			let data = {
				extType: null, //1:手机号，2:邮箱，3:用户名
				type: this.formData.type, //1:密码登录，2:验证码登录
				password: hashPassword,
				authCode: this.formData.authCode,
				areaCode: this.mobile_prefix,
			}
			// 判断登录账号类型
			let accountTypeArr = [
				{
					extType: 1,
					type: 'phone',
					reg: isPhone,
				},
				{
					extType: 2,
					type: 'email',
					reg: isEmail,
				},
			]
			let accountType = accountTypeArr.find((item) => item.reg.test(this.formData.account))
			this.accountType = accountType
			if (!accountType) {
				//用户名登录
				data.extType = 3
				data.username = this.formData.account
			} else {
				data.extType = accountType.extType
				data[accountType.type] = this.formData.account
			}
			return data
		},
		postAccountGetAuthCode() {
			// 校验手机号、邮箱
			this.$refs.form.validateField('account', (err) => {
				console.log(err, err === '')
				if (!err) {
					if (this.Countdown.time > 0) return
					this.Countdown.time = 60
					this.setCountdown()

					// 判断登录账号类型
					let accountTypeArr = [
						{
							extType: 1,
							type: 'phone',
							reg: isPhone,
						},
						{
							extType: 2,
							type: 'email',
							reg: isEmail,
						},
					]
					let accountType = accountTypeArr.find((item) => item.reg.test(this.formData.account))

					if (accountType.type === 'phone') {
						this.$api.account_new.getPhoneAuthCode4Login({ phone: this.formData.account, areaCode: this.mobile_prefix })
					} else if (accountType.type === 'email') {
						this.$api.account_new.getMailAuthCode4Login({ mail: this.formData.account })
					}
				}
			})
		},
		setCountdown() {
			let Countdown = null
			Countdown = setInterval(() => {
				this.Countdown.time--
				if (this.Countdown.time <= 0) {
					clearInterval(Countdown)
				}
			}, 1000)
		},
		setActiveName(val) {
			this.activeName = val
			if (this.activeName === 'password') {
				this.formData.type = 1
				this.$refs.form.clearValidate()
			} else {
				this.formData.type = 2
				this.$refs.form.clearValidate()
			}
		},
	},
}
</script>

<style lang="stylus" scoped>
// @import './css/index.styl';
// .login_wrap
// 	/deep/ .el-form-item__error
// 		left 0
// 		padding-top 8px

// 	.tabs li
// 		cursor: pointer

// 	.password
// 		margin 12px
// 		font-size 16px

	// /deep/ .el-input__inner
	// 	box-shadow 0 0 0 1000px #ffffff inset

// 	/deep/ .el-input-group__append
// 		border 0;
// .login-international{
// 	cursor default
// 	display: flex;
// 	align-items: center;
// 	border-radius 4px
// 	position absolute;
// 	top 16px;
// 	right 0px;
// 	width 120px;
// 	height 40px;
// 	.international-img{
// 		width 14px
// 		height 14px
// 		margin-left: 6px;
// 	}
// 	img {
// 		width 24px
// 		height 16px
// 		margin-right 8px
// 	}
// 	span{
// 		color #666666;
// 		max-width 120px
// 		overflow hidden
// 		text-overflow ellipsis
// 		white-space nowrap
// 	}
// 	i{
// 		color #ffffff
// 		margin-left 12px
// 	}
// 	ul{
// 		box-shadow 0px 0px 8px 2px rgba(3, 3, 3, 0.1)
// 		position absolute
// 		top 40px
// 		right 16px
// 		z-index 9
// 		display inline-block
// 		padding 4px 0
// 		border-radius 4px
// 		background-color #fff
// 		li{
// 			text-align center
// 			width: 87px;
// 			padding 0 16px
// 			height 32px
// 			font-size 14px
// 			line-height 32px
// 			color #333333
// 			overflow hidden
// 			text-overflow ellipsis
// 			white-space nowrap
// 		}
// 	}
// }
</style>
